// Starting point for a new map: an empty rectangle with only what every map must have.
import type { MapData, MapObjects } from './schema.js';

const emptyObjects = (): MapObjects => ({
  camps: [], bridges: [], trees: [], rocks: [], pillars: [], walls: [], buildings: [],
  streams: [], ponds: [], cliffs: [], brush: [], roads: [], decor: [],
  props: [], fields: [], fords: [],
});

/** A valid map of width x height metres: base bottom-left, point A on the red half, B at the centre,
    a griffin den on the red half (its mirror is the behemoth's). Positions scale with the map. */
export function newBlankMap(width: number, height: number, name = 'untitled'): MapData {
  return {
    format: 1,
    name,
    width,
    height,
    pointRadius: 3.6,
    base: [-0.4 * width, 0.35 * height],
    points: { side: [-0.15 * width, 0.3 * height], center: [0, 0] },
    den: { kind: 'griffin', pos: [0.38 * width, 0.34 * height] },
    half: emptyObjects(),
    center: emptyObjects(),
  };
}
